import { createContext, ReactNode, useContext } from "react";

import { OverviewPageAnalytics } from "../types";

type OverviewAnalyticsContextType = {
  analytics?: OverviewPageAnalytics;
};

const OverviewAnalyticsContext = createContext<OverviewAnalyticsContextType>(
  {},
);

type OverviewAnalyticsProviderProps = {
  children: ReactNode;
  analytics?: OverviewPageAnalytics;
};

export const OverviewAnalyticsProvider = ({
  children,
  analytics,
}: OverviewAnalyticsProviderProps) => {
  return (
    <OverviewAnalyticsContext.Provider value={{ analytics }}>
      {children}
    </OverviewAnalyticsContext.Provider>
  );
};

export const useOverviewAnalytics = () => {
  return useContext(OverviewAnalyticsContext);
};
